import api from './api';

const getAdvised = (payload) => {
  return api.post('api/customer-campaign/get-advised', null, payload, {
    timeout: 70000,
    baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL,
  });
};

const serviceLeads = (payload: { [key: string]: any; isConsent: boolean }) => {
  return api.post('customer/v1/inquiry/service-leads', null, payload, { timeout: 70000 });
};

const toyotaHomeService = (payload) => {
  return api.post('customer/v1/inquiry/toyota-home-service', null, payload, { timeout: 70000 });
};

const orderPartsAccessories = (payload: { [key: string]: any; isConsent: boolean }) => {
  return api.post('customer/v1/inquiry/order-parts-accessories', null, payload, { timeout: 70000 });
};

const submitOthers = (payload) => {
  return api.post('customer/v1/inquiry/submit-inquiry-other', null, payload, { timeout: 70000 });
};

export default {
  getAdvised,
  serviceLeads,
  toyotaHomeService,
  orderPartsAccessories,
  submitOthers,
};
